import React from 'react';
import { Chip as MuiChip } from '@mui/material';

import { useStyles } from '~/assets/styles';
import cn from '~/Utils/cn';

/**
 This Component is a wrapper on MUI component.
 This component should be imported and not MUI directly!
**/

interface ClassKeyValue {
  [name: string]: string;
}

export interface ChipProps {
  className?: string;
  avatar?: React.ReactElement;
  clickable?: boolean;
  color?: 'primary' | 'secondary' | 'default';
  deleteIcon?: React.ReactElement;
  disabled?: boolean;
  icon?: React.ReactElement;
  label?: React.ReactNode;
  onDelete?: React.MouseEventHandler<HTMLButtonElement>;
  size?: 'small' | 'medium';
  /** v5 renamed the filled variant from `default` to `filled`; it stays the default, so no call site passes it. */
  variant?: 'filled' | 'outlined';
  classes?: ClassKeyValue;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  /** A chip standing for one option of a filter has to say whether that option is the active one. */
  'aria-pressed'?: boolean;
  /** For a chip that opens a popover: the props `usePopoverState` returns as `triggerProps`. */
  'aria-haspopup'?: React.AriaAttributes['aria-haspopup'];
  'aria-expanded'?: boolean;
  'aria-controls'?: string;
}

const Chip: React.VFC<ChipProps> = ({ className, ...chipProps }) => {
  const { classes } = useStyles();

  return <MuiChip {...chipProps} className={cn(classes.chip, className)} />;
};

export default Chip;
